import { claimQuery, claimsListQueryKey } from "@/api/claims";
import { api, queryClient } from "@/api/utils";
import { seo } from "@/utils/seo";
import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/claims/$claimId")({
  component: lazyRouteComponent(() => import("./+Claim")),
  loader: ({ params, preload }) => {
    // Don't assign on intent-preload (hover) — only when the page is actually visited.
    // assignClaim is a safe no-op unless the claim is still Pending, so it's fine to fire
    // on every visit regardless of entry point (list link, Slack deep-link, direct URL).
    if (preload) return;
    void api.claims
      .assignClaim({ claimId: params.claimId })
      .then(() => {
        queryClient.invalidateQueries(claimQuery(params.claimId));
        queryClient.invalidateQueries({ queryKey: claimsListQueryKey });
      })
      .catch(() => {});
  },
  head: () => ({ meta: seo({ title: "Claim Review" }) }),
});
